import * as tslib_1 from "tslib";
import { create } from '@wix/fedops-logger';
import { getTranslations } from '@wix/wixstores-client-core/dist/src/viewer-script/utils';
import { translationPath } from '../constants';
import { ProductApi } from '../services/productApi';
import { MultilingualService } from '@wix/wixstores-client-core/dist/src/multilingualService/multilingualService';
import { overrideTranslationsWithPublicData } from './productWidgetStore.utils';
import { ProductService } from '../services/ProductService';
import { PubSubManager } from '@wix/wixstores-client-core/dist/es/src/pub-sub-manager/pubSubManager';
import { WidgetActionEnum } from '../commons/styleParamsService';
import { PageMap } from '@wix/wixstores-client-core/dist/es/src/constants';
var ProductWidgetStore = /** @class */ (function () {
    function ProductWidgetStore(styleParams, publicData, setProps, siteStore, externalId, compId, reportError) {
        var _this = this;
        this.styleParams = styleParams;
        this.publicData = publicData;
        this.setProps = setProps;
        this.siteStore = siteStore;
        this.externalId = externalId;
        this.compId = compId;
        this.reportError = reportError;
        this.fedopsLogger = create('wixstores-client-product-widget');
        this.isReported = false;
        this.onAppLoaded = function () {
            if (!_this.isReported) {
                _this.fedopsLogger.appLoaded();
            }
            _this.isReported = true;
        };
        this.handleAddToCart = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var navigate;
            return tslib_1.__generator(this, function (_a) {
                navigate = this.styleParams.fonts.widgetAction.value === WidgetActionEnum.NAVIGATE || this.product.price === 0;
                return [2 /*return*/, this.productService.addToCart(this.product, navigate)];
            });
        }); };
        this.onAppLoaded();
        this.productApi = new ProductApi(this.siteStore);
        this.pubSubManager = new PubSubManager(this.siteStore.pubSub);
        this.productService = new ProductService(siteStore, this.pubSubManager, compId, externalId);
    }
    ProductWidgetStore.prototype.getTexts = function () {
        var _this = this;
        return Object.keys(this.translations).reduce(function (res, key) {
            res[key] = _this.multilingualService.get(key) || _this.translations[key];
            return res;
        }, {});
    };
    ProductWidgetStore.prototype.getProductWidgetTranslations = function () {
        return getTranslations(translationPath(this.siteStore.baseUrls.productWidgetBaseUrl, this.siteStore.locale));
    };
    ProductWidgetStore.prototype.setInitialState = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, translations, data, url, propsToInject;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.getProductWidgetTranslations(),
                            this.productApi.getData(this.externalId, this.compId),
                            this.siteStore.getSectionUrl(PageMap.PRODUCT),
                        ]).catch(this.reportError)];
                    case 1:
                        _a = _b.sent(), translations = _a[0], data = _a[1].data, url = _a[2].url;
                        this.product = data.catalog.product;
                        this.translations = overrideTranslationsWithPublicData(translations, this.publicData);
                        this.multilingualService = new MultilingualService(this.publicData.COMPONENT || {}, data.appSettings.widgetSettings, this.siteStore.getMultiLangFields(), this.siteStore.locale);
                        propsToInject = {
                            cssBaseUrl: this.siteStore.baseUrls.productWidgetBaseUrl,
                            isLoaded: true,
                            product: this.product,
                            texts: this.getTexts(),
                            handleAddToCart: this.handleAddToCart,
                            productPageUrl: url + "/" + this.product.urlPart,
                        };
                        this.setProps(propsToInject);
                        return [2 /*return*/];
                }
            });
        });
    };
    ProductWidgetStore.prototype.updateState = function (newStyleParams, newPublicData) {
        this.publicData = newPublicData;
        this.styleParams = newStyleParams;
        this.translations = overrideTranslationsWithPublicData(this.translations, this.publicData);
        this.setProps({
            texts: this.getTexts(),
        });
    };
    return ProductWidgetStore;
}());
export { ProductWidgetStore };
//# sourceMappingURL=productWidgetStore.js.map